// oxlint-disable no-useless-escape

// Global setup
export const viewQuery = {
  query: undefined,
  today: new Date(),
};

export const fm = {
  areas: {},
  categories: {},
  categoriesList: [],
  tags: [],
  mood: [],
  energy: [],
  clarity: [],
  goals: {},
  cycles: ['wake', 'rise', 'sleep'],
  rhythm: ["m", "e", "c"],
};

export const urls = {
  Goals: 'obsidian://open?vault=MainVault&file=Plan%2F%40Goals%202023',
  Projects: 'obsidian://open?vault=MainVault&file=Plan%2F%40Projects',
};

export const files = {
  logPath: "public/data/_Loglink.md",
  configPath: "public/data/config.txt",
  goalsPath: "public/data/goals.txt",
  frontMatter: "",
}

export const settings = {
  flow: 8,
  dayStartTime: 5,
}

export const unitType = {
  pushups: 'reps',
  horsestance: 'secs',
  supine_press: 'weight',
  cycling: 'distance',
  sit: 'time',
}

// Misc
export const ui = {
  dayStartTime: 4,
  dayLength: 24,
  selectorAreaDefault: "New: ",
  selectorProjectDefault: "New: ",
  dayNames: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
  dayNamesShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
  monthNames: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
  monthNamesShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
  keys: ['clarity', 'cycles', 'energy', 'habits', 'mood', 'mood_simple', 'rhythmFlow', 'slept', 'summary'],
  entryMaxWidth: 100,
}

export const regExes = {
  lines: /.*[^\n]/g,          // new line in the file
  time: /\d{1,2}:\d{1,2}/g,
  timeNn: /\d{1,2}/g,          // gets 00 out of 00:00
  splitTime: /[0-9][0-9]/g,
  tag: /(^|)#(?![0-9]+\b)([a-zA-Z0-9\-_+]{1,30})(\b|\r)/g,   // #tag#tag works
  tagString: /\s(^|)(?![0-9]+\b)([a-zA-Z0-9\-_+]{1,30})(\b|\r)/g,
  eachHeader: /\w*\s*\w*[^\|\s]/g,
  eachItem: /[^|]+/g,
  date: / \d{1,4}\/\d{1,2}\/\d{1,2}/g,      // YYYY/MM/DD
  dateLogEntry: /^\d{1,4}\/\d{1,2}\/\d{1,2}/g,      // only matches if its first line
  whitespace: /^\s*$/g,        // any
  spaces: /\s{1,}/g,
  frontMatterLineStart: /[@$!]/g,
  frontMatterTaxonomy: /[@$!]\w{1,}/g, // anything starting with @, $ or !
  frontMatterAreas: /[@]\w{1,}/g,   // starting with @ then a letter
  frontMatterCategories: /[$]\w{1,}/g,   // starting with $ then a letter
  frontMatterGoals: /^(?!\!\!)!\w{1,}/,   // starting with ! then a letter / [!{1}][\w\d\-_+]{1,}
  frontMatterGoalsEnd: /!![\w]{1,}/,
  frontMatterComment: /^\/\//g,    // comment starting with `//`
  moodTag: /m\d{1,2}/g,
  energyTag: /e\d{1,2}/g,
  clarityTag: /c\d{1,2}/g,
  rhythmTag: /[m|e|c]\d{1}/,
  categoryListSymbol: /@\w{1,}/g,
  URL: /(?:(?:\w{1,}):\/\/)?[\w/\-?=%.]+[\.\?]{1}[\w/\S\-@:&?%+,=()]{2,}/g,
  // oldURL:                 /(?:(?:\w{1,}):\/\/)?[\w/\-?=%.]+\.{1}[\w/\-@:&?%+,.=()]{2,}/g,
  JSON: /\{.*\}/g,
  JSON_key: /\d*[a-zA-Z][a-zA-Z0-9_-]{1,}/,
  comment: /"[\w\s\S]{1,}"/,
  urlAnchor: /#(?=\w{1,})[\w\-]*$/,
};
